(function () {
  const CONFIG = {
    freeVariantId: 52874732732713,
    minimumSpend: 5000, // ← whole ISK amount (e.g. 5000 = 5.000 kr)
  };

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addFreeItem() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: CONFIG.freeVariantId, quantity: 1 }],
      }),
    });
  }

  async function removeFreeItem(linePos) {
    const updates = {};
    updates[linePos] = 0;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
  }

  function lockFreeItemUI() {
    const input = document.querySelector(`[data-quantity-variant-id="${CONFIG.freeVariantId}"]`);
    if (!input) return;
    const wrapper = input.closest('quantity-input');
    if (!wrapper) return;
    wrapper.querySelectorAll('.quantity__button').forEach(btn => btn.style.display = 'none');
    input.setAttribute('readonly', true);
    input.style.pointerEvents = 'none';
  }

  async function enforceQuantity(cart) {
    const freeItem = cart.items.find(item => item.variant_id === CONFIG.freeVariantId);
    if (freeItem && freeItem.quantity > 1) {
      const linePos = cart.items.indexOf(freeItem) + 1;
      const updates = {};
      updates[linePos] = 1;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    }
  }

  async function evaluateCart() {
    const cart = await getCart();
    const collectionProductIds = window.QUALIFYING_PRODUCT_IDS || [];

    const qualifyingItems = cart.items.filter(
      item => collectionProductIds.includes(item.product_id) && item.variant_id !== CONFIG.freeVariantId
    );

    // ISK has no decimals — Shopify still stores prices in minor units (same as cents)
    // so we divide by 100 to get the whole ISK amount
    const qualifyingTotal = qualifyingItems.reduce((sum, item) => sum + item.final_line_price, 0) / 100;

    const freeItemInCart = cart.items.find(item => item.variant_id === CONFIG.freeVariantId);

    await enforceQuantity(cart);

    if (qualifyingTotal >= CONFIG.minimumSpend && !freeItemInCart) {
      await addFreeItem();
    } else if (qualifyingTotal < CONFIG.minimumSpend && freeItemInCart) {
      const linePos = cart.items.indexOf(freeItemInCart) + 1;
      await removeFreeItem(linePos);
    }

    lockFreeItemUI();
  }

  function initListeners() {
    document.addEventListener('cart:updated', evaluateCart);
    document.addEventListener('cart:refresh', evaluateCart);

    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[action="/cart/add"]')) {
        setTimeout(evaluateCart, 800);
      }
    });

    evaluateCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initListeners);
  } else {
    initListeners();
  }
})();